import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SidenavService } from 'app/library/grow/services/sidenav.service';
import { ExperienceWidget } from 'app/library/experience-widgets/models/experience-widget.model';
import { ExperienceWidgetService } from 'app/library/experience-widgets/services/experience-widget.service';
import { MaxBrainExperience } from 'app/library/experience/models/experience.model';
import { HeaderBannerStream } from 'app/library/experience/models/header-banner-stream.model';
import { ExperienceService } from 'app/library/experience/services/experience.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { filter, take, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-widgets',
    templateUrl: './widgets.component.html',
    styleUrls: ['./widgets.component.scss'],
})
export class WidgetsComponent extends UnsubscribeOnDestroy implements OnInit {
    stream: { headerBannerStream: HeaderBannerStream; headerStream: ExperienceWidget[] } = {
        headerBannerStream: null,
        headerStream: [],
    };

    experienceWidgets: ExperienceWidget[] = [];
    experienceId: string;
    experience: MaxBrainExperience;

    screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    @HostListener('window:resize')
    onResize() {
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    constructor(
        private _cdr: ChangeDetectorRef,
        private _experienceService: ExperienceService,
        private _experienceWidgetsService: ExperienceWidgetService,
        private _location: Location,
        private _route: ActivatedRoute,
        public sidenavService: SidenavService
    ) {
        super();
        this.experienceWidgets = [];
    }

    async ngOnInit(): Promise<void> {
        this.experienceId = this._route.snapshot.parent.params.id;
        this._experienceWidgetsService.getExperienceWidgetById(this.experienceId);
        await this._experienceWidgetsService.fetchExperienceWidgets(this.experienceId);

        this._experienceService.experience$
            .pipe(
                filter((x) => !!x),
                take(1)
            )
            .subscribe(async () => {
                this.experience = this._experienceService.getExperienceById(this.experienceId);

                this._cdr.detectChanges();
                this.experienceWidgets = [];
            });

        this._experienceWidgetsService.experienceWidget$
            .pipe(
                filter((x) => !!x),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((experienceWidgets) => {
                for (let i = 0; i < experienceWidgets.length; i++) {
                    const widget = experienceWidgets[i];
                    if (widget.name === 'header_banner_stream') {
                        this.stream.headerBannerStream = widget;
                    } else if (widget.name.startsWith('header_stream')) {
                        this.stream.headerStream.push(widget);
                    } else {
                        this.experienceWidgets.push(widget);
                    }
                }
            });
    }

    goBack() {
        this._location.back();
    }

    openEditExperienceWidgetDialog(): void {}

    ngOnDestroy(): void {
        this._experienceWidgetsService.clearExperienceWidgetsState();
        this.experienceWidgets = [];
    }
}
